// export const urlPhp8Default = "https://middleware-desarrollo.aigsegurosmexico.com/";
export const urlPhp8Default = "http://localhost/middPhp8/";

export const urlBase = process.env.REACT_APP_URL_PHP_8 || urlPhp8Default;

const ambienteDefault = "desarrollo";

export let ambienteAplicacion = process.env.REACT_APP_AMBIENTE || ambienteDefault; //Utilizado solo para produccion

export const ambientes = {
  DEV: "desarrollo",
  PROD: "produccion",
};

export const emp = "AIGMEXGARANPLUS";
export const plataforma1 = "WEB";
export let ambiente = `&ambiente=${ambienteAplicacion}`; //Utilizado solo para produccion

const XDEBUG = `&XDEBUG_SESSION_START=name`;

export const controlador = "frontend/web/index.php?r=";
export const empresa = `&empresa=${emp}`;
export const plataforma = "&plataforma=" + plataforma1;

export const urlCatalogoInicial = `${urlBase}${controlador}garantias/catalogo-inicial${XDEBUG}`;

export const urlMunicipios = `${urlBase}${controlador}garantias/obtener-municipios`;

export const urlTiendas = `${urlBase}${controlador}garantias/obtener-tienda`;

export const urlPPC = `${urlBase}${controlador}garantias/ppc`;

export const urlUploadFile = `${urlBase}${controlador}app/upload-file&empresa=${emp}`;

export const urlGuardarGarantia = `${urlBase}${controlador}garantias/guardar-informacion`;

export const urlObtenerEstados = `${urlBase}${controlador}garantias/obtener-estados`;
